import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import OnboardingShell from '../Experience/components/ExperienceShell';
import PlanSelection from '../Experience/components/PlanSelection';
import StationManagement from './components/StationManagement';
import MenuLinking from './components/MenuLinking';
import SpaceLinking from './components/SpaceLinking';
import ExperienceComplete from './components/ExperienceComplete';

const StationExperience = () => {
    const navigate = useNavigate();
    const [currentStep, setCurrentStep] = useState(0);
    const [state, setState] = useState({
        plan: 'enterprise',
        stations: [],
        menuLinks: {}, // stationId -> [menuIds]
        spaceLinks: {}, // stationId -> [spaceIds]
        tokens: []
    });

    const steps = [
        { id: 'plan', title: 'Plan Selection', component: PlanSelection },
        { id: 'stations', title: 'Station Management', component: StationManagement },
        { id: 'menus', title: 'Link Menus', component: MenuLinking },
        { id: 'spaces', title: 'Link Spaces', component: SpaceLinking },
        { id: 'complete', title: 'All Set', component: ExperienceComplete }
    ];

    const updateState = (newState) => {
        setState(prev => ({ ...prev, ...newState }));
    };

    const handleNext = () => {
        if (currentStep < steps.length - 1) {
            setCurrentStep(currentStep + 1);
        } else {
            navigate('/dashboard');
        }
    };

    const handleBack = () => {
        if (currentStep > 0) {
            setCurrentStep(currentStep - 1);
        }
    };

    const CurrentStepComponent = steps[currentStep].component;

    return (
        <OnboardingShell
            currentStep={currentStep + 1}
            totalSteps={steps.length}
            plan={state.plan}
            onBack={currentStep > 0 ? handleBack : undefined}
            onNext={handleNext}
            nextLabel={currentStep === steps.length - 1 ? 'Go to Dashboard' : 'Continue'}
        >
            {CurrentStepComponent && (
                <CurrentStepComponent
                    state={state}
                    updateState={updateState}
                    onNext={handleNext}
                    onBack={handleBack}
                />
            )}
        </OnboardingShell>
    );
};

export default StationExperience;
